import { Avatar } from '@/components';
import { initialsOf } from '@/lib/format';
import type { Superlative } from './scoreboard';

/**
 * The 🏆 / 🚀 / 💯 cards. Deliberately as prominent as any single score so the
 * spotlight spreads beyond the top scorer. Cards with no winner are already
 * omitted upstream (computeSuperlatives), so this never renders an empty award.
 */
export function SuperlativeStrip({ items }: { items: Superlative[] }) {
  if (items.length === 0) return null;
  return (
    <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
      {items.map((s) => (
        <div
          key={s.kind}
          style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 18px',
            background: 'var(--card)', border: '1px solid var(--line)', borderRadius: 16, boxShadow: '0 2px 10px rgba(0,0,0,.06)',
          }}
        >
          <span style={{ fontSize: 30, lineHeight: 1 }}>{s.icon}</span>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="eyebrow">{s.label.en}</span>
            <span style={{ fontSize: 22, fontWeight: 800, color: 'var(--ink-2)', lineHeight: 1.1 }}>{s.value}</span>
          </div>
          <div style={{ display: 'flex', marginLeft: 2 }}>
            {s.winners.slice(0, 4).map((w, i) => (
              <div key={i} style={{ marginLeft: i ? -10 : 0, borderRadius: '50%', border: '2px solid var(--card)' }}>
                <Avatar initials={initialsOf(w.name.split(' ')[0], w.name.split(' ')[1] ?? '')} size={34} tone={w.tone ?? 'slate'} photoUrl={w.photoUrl} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
